import type { Config } from './types';
import defaults from './defaults';

export const applyDefaults = (config: Partial<Config> = {}): Config => ({
  ...defaults,
  ...config
});
